import styled from 'styled-components';

export const WarningMessage = styled.p`
  border: 1px solid orange;
  padding: 10px;
  background-color: #FFFBE8;
  border-radius: 5px;
`

import { Form, Input, Alert } from 'antd';

export const FormItemStyled = styled(Form.Item)`
  label {
    font-weight: inherit;
    color: inherit !important;
  }
`
